import { ApplicationView, useController } from '@aha-app/mvc';
import classNames from 'classnames';
import React from 'react';
import customElementBoolAttr from '../../../utils/customElementBoolAttr';
import VotingSessionController from './controllers/VotingSessionController';
import { pluralize } from '@aha-app/aha-shared';
import styles from './VotingSession.module.css';

export const VotingSetupVoteLimitControls = ApplicationView(() => {
  const controller = useController(VotingSessionController);
  const { votesPerPerson, votesLimited } = controller.state;
  let voteLimitText = 'No limit';
  if (votesLimited) {
    voteLimitText = `${pluralize(votesPerPerson, 'vote')} per person`;
  }

  return (
    <li className='flex-row flex-row--align-center flex-row--justify-space-between'>
      <div className='flex-row flex-row--align-center gap-2'>
        <span className='h-300'>
          <strong>{votesPerPerson}</strong>
        </span>
        <aha-menu>
          <span
            slot='control'
            className={classNames('t-100', styles.menuTrigger)}
          >
            {voteLimitText}
            <aha-icon class='ml-1' icon='fa-solid fa-chevron-down' />
          </span>
          <aha-menu-content>
            <aha-menu-group>
              <aha-menu-item
                selected={customElementBoolAttr(votesLimited)}
                onClick={() => controller.actionSetVotesLimited(true)}
              >
                Per person
              </aha-menu-item>
            </aha-menu-group>
            <aha-menu-group>
              <aha-menu-item
                selected={customElementBoolAttr(!votesLimited)}
                onClick={() => controller.actionSetVotesLimited(false)}
              >
                No limit
              </aha-menu-item>
            </aha-menu-group>
          </aha-menu-content>
        </aha-menu>
      </div>
      <div className='flex-row gap-2 py-1'>
        <aha-button
          kind='gray'
          class={styles.votingSquareButton}
          disabled={customElementBoolAttr(!votesLimited || votesPerPerson <= 1)}
          onClick={() => controller.actionSetVotesPerPerson(votesPerPerson - 1)}
        >
          <i className='fa-solid fa-minus' />
        </aha-button>
        <aha-button
          kind='gray'
          class={styles.votingSquareButton}
          disabled={customElementBoolAttr(!votesLimited)}
          onClick={() => controller.actionSetVotesPerPerson(votesPerPerson + 1)}
        >
          <i className='fa-solid fa-plus' />
        </aha-button>
      </div>
    </li>
  );
});
